var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6694 9.00048C25.4655 8.37315 24.9246 7.91869 24.2729 7.8235L17.6729 6.86448L14.721 0.88838C14.1385 -0.293634 12.2048 -0.293634 11.6223 0.88838L8.67042 6.86448L2.08582 7.8235C1.43436 7.91869 0.893467 8.37474 0.691162 9.00048C0.487266 9.62781 0.658286 10.314 1.13024 10.7719L5.90364 15.4122L4.77863 21.9796C4.66806 22.6276 4.93427 23.2843 5.46641 23.6715C6.00041 24.0567 6.70729 24.1071 7.28796 23.8011L13.171 20.6989L19.0712 23.8011C19.3237 23.9342 19.6002 24 19.8749 24C20.2326 24 20.5903 23.8894 20.8946 23.6717C21.4271 23.2828 21.693 22.6279 21.5824 21.9798L20.4574 15.4125L25.2308 10.7722C25.7023 10.3156 25.8733 9.62596 25.6694 9.00048ZM17.391 13.5681C16.9832 13.9656 16.7947 14.5378 16.8915 15.0993L17.5793 19.1123L13.9725 17.2165C13.722 17.0834 13.4454 17.0177 13.1689 17.0177C12.8923 17.0177 12.6158 17.0834 12.3652 17.2165L8.77754 19.1073L9.46532 15.0996C9.5621 14.538 9.37385 13.9642 8.9658 13.5684L6.05557 10.7393L10.0667 10.1552C10.6282 10.074 11.114 9.71955 11.3664 9.20994L13.1689 5.55811L14.9713 9.20994C15.2237 9.72141 15.7092 10.074 16.2726 10.1552L20.2994 10.7412L17.391 13.5681Z",
    fill: "#FBCB21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.67018c00f8653a04554837d46d60863f.svg";
export { ForwardRef as ReactComponent };